import { useEffect } from 'react';
import { useQuery } from '@apollo/client/react';

import { SkillDocument } from 'graphql/types';
import { useApolloError } from 'common/hooks/useApolloError';

interface IUseSkillCertificateColumnsOptions {
    skillId: string | undefined;
    skip?: boolean;
}

// Sources the canonical certificate list for a skill (skill→certificate
// relationship), independent of which users are visible. Reuses SkillDocument
// because the existing Skill fragment already includes skillCertificates and
// Apollo caches the result by skill id.
export const useSkillCertificateColumns = ({
    skillId,
    skip = false,
}: IUseSkillCertificateColumnsOptions) => {
    const { showApolloError } = useApolloError();

    const { loading, data, error } = useQuery(SkillDocument, {
        variables: { id: skillId ?? '' },
        skip: skip || !skillId,
        fetchPolicy: 'cache-first',
    });

    useEffect(() => {
        if (error) {
            showApolloError(error);
        }
    }, [error, showApolloError]);

    return {
        skillCertificates: data?.skill?.skillCertificates ?? [],
        loading,
    };
};
